<ngx-charts-bar-horizontal-stacked [view]="view" [scheme]="colorScheme" [results]="multi" [gradient]="gradient"
    [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel">
</ngx-charts-bar-horizontal-stacked>